import fr_en from './france/en'
import fr_fr from './france/fr'
import it_it from './italy/it'
import it_en from './italy/en'
import unieuro_it from './unieuro/it'
import unieuro_en from './unieuro/en'
import de_de from './germany/de'
import de_en from './germany/en'
import at_de from './austria/de'
import at_en from './austria/en'

export default {
  france: {
    en: fr_en,
    de: fr_fr,
    fr: fr_fr,
    it: fr_fr,
  },
  italy: {
    en: it_en,
    de: it_it,
    fr: it_it,
    it: it_it,
  },
  unieuro: {
    en: unieuro_en,
    de: unieuro_it,
    fr: unieuro_it,
    it: unieuro_it,
  },
  germany: {
    en: de_en,
    de: de_de,
    fr: de_de,
    it: de_de,
  },
  austria: {
    en: at_en,
    de: at_de,
    fr: at_de,
    it: at_de,
  },
}
